// @flow
import FontAwesome from 'react-fontawesome';
import { Tab, Col, NavItem, Row, Nav } from 'react-bootstrap';
import React, { Component } from 'react';
import style from './style';

import locale from '../../../../locales/index';
import api from '../../../../services/api';

import Personal from '../Personal/Personal';
import SpeechAndLanguage from '../SpeechAndLanguage/SpeechAndLanguage';
import News from '../News/News';
import Account from '../Account/Account';
import Medication from '../Medication/Medication';
import Calling from '../Calling/Calling';
import Radio from '../Radio/Radio';
import BrandedPage from '../BrandedPage/BrandedPage';

class Tabs extends Component<{
  user: Object,
}> {
  tabs: Array<Object> = [];

  generateMenu() {
    const items = [];
    const adminType = api.getCurrentUser().type;

    // settings for all users
    items.push(<NavItem key="menu1" eventKey={1}><FontAwesome name="user" /> {locale.personal}</NavItem>);
    items.push(<NavItem key="menu2" eventKey={2}><FontAwesome name="commenting-o" /> {locale.speechAndLang}</NavItem>);
    items.push(<NavItem key="menu3" eventKey={3}><FontAwesome name="newspaper-o" /> {locale.news}</NavItem>);
    items.push(<NavItem key="menu6" eventKey={6}><FontAwesome name="phone" /> {locale.calling}</NavItem>);
    items.push(<NavItem key="menu7" eventKey={7}><FontAwesome name="music" /> {locale.radio}</NavItem>);

    // settings for superAdmin and admin
    if (adminType === 'su' || adminType === 'admin') {
      items.push(<NavItem key="menu5" eventKey={5}><FontAwesome name="medkit" /> {locale.medication}</NavItem>);
      items.push(<NavItem key="menu8" eventKey={8}><FontAwesome name="info-circle " /> {locale.brandedPage}</NavItem>);
    }

    // settings for superAdmin only
    if (adminType === 'su') {
      items.push(<NavItem key="menu4" eventKey={4}><FontAwesome name="cog" /> {locale.accountSettings}</NavItem>);
    }

    return items;
  }

  render() {
    this.tabs = [];

    return (
      <Tab.Container id="left-tabs-example" defaultActiveKey={1}>
        <Row className="clearfix">
          <Col sm={3}>
            <Nav bsStyle="pills" stacked>
              {this.generateMenu()}
            </Nav>
          </Col>
          <Col sm={9} style={style.body}>
            <Tab.Content animation>
              <Tab.Pane eventKey={1}><Personal user={this.props.user} /></Tab.Pane>
              <Tab.Pane eventKey={2}>
                <SpeechAndLanguage
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={3}>
                <News
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={4}>
                <Account
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={5}>
                <Medication
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={6}>
                <Calling
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={7}>
                <Radio
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={8}>
                <BrandedPage
                  user={this.props.user}
                  ref={(instance) => { this.tabs.push(instance); }}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Tabs/Tabs.js